export const IS_ACTIVE = {
  true: 'เปิดใช้งาน',
  false: 'ปิดใช้งาน',
}

export const PRODUCT_STATUS = {
  all: 'ทั้งหมด',
  accessory: 'อุปกรณ์เสริม',
  warranty: 'การรับประกัน',
  delivery: 'จัดส่ง',
  free: 'ฟรี',
  accessory_bundle: 'สินค้าเสริม',
}
